import { render, staticRenderFns } from "./SpecificationDialog.vue?vue&type=template&id=4c5e6412&scoped=true&"
import script from "./SpecificationDialog.vue?vue&type=script&lang=js&"
export * from "./SpecificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationDialog.vue?vue&type=style&index=0&id=4c5e6412&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e6412",
  null
  
)

export default component.exports